import { render, staticRenderFns } from "./ValveDetail.vue?vue&type=template&id=9a9c2864&scoped=true"
import script from "./ValveDetail.vue?vue&type=script&lang=js"
export * from "./ValveDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a9c2864",
  null
  
)

export default component.exports